webpackJsonp([71976610319244],{

/***/ 486:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter Blog","author":"Kyle Mathews"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2017-11-17-wod/index.md absPath of file >>> MarkdownRemark","html":"<h2>Friday 11/17</h2>\n<p>Run 0.5 miles\n16 DB clean &#x26; jerks\n9 dips</p>\n<p>Run 0.5 miles\n7 DB clean &#x26; jerks\n9 dips</p>\n<p>Run 0.5 miles\n4 DB clean &#x26; jerks\n9 dips</p>\n<p>Use two 40 lbs dumbbells for the C&#x26;J.</p>","frontmatter":{"title":"WOD 11.17.2017","date":"November 17, 2017"}}},"pathContext":{"path":"/wod-2017-11-17/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---wod-2017-11-17-c7dbded77bf940f7cd42.js